import { useLocalStorage } from 'usehooks-ts';
import { useQuery } from '@tanstack/react-query';
import useMultiTokenData from './useMultiTokenData';
export default function useListedTokenData({
  enabled = true
} = {}) {
  const [listedTokenLC, setListedTokensLC] = useLocalStorage('listedTokens', []);
  const query = useQuery({
    queryKey: ['listedTokens'],
    queryFn: async () => {
      var _a, _b;
      const payload = await fetch('/api/explore/getListedTokens', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await payload.json();
      setListedTokensLC((_a = data === null || data === void 0 ? void 0 : data.tokens) === null || _a === void 0 ? void 0 : _a.data_json);
      return (_b = data === null || data === void 0 ? void 0 : data.tokens) === null || _b === void 0 ? void 0 : _b.data_json;
    },
    refetchInterval: 60 * 1000,
    enabled
  });
  const listedTokens = listedTokenLC || query.data;
  const {
    data: subMemeDataRaw,
    isLoading: subMemeLoading
  } = useMultiTokenData({
    tokens: listedTokens === null || listedTokens === void 0 ? void 0 : listedTokens.map(token => `${token.token}:${token.chain}`)
  });
  const subMemeData = subMemeDataRaw === null || subMemeDataRaw === void 0 ? void 0 : subMemeDataRaw.map(item => {
    var _a;
    // @todo: fix this, expensive operation
    return Object.assign(Object.assign({}, item), {
      category: (_a = listedTokens.find(token => {
        var _a, _b, _c;
        return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = item === null || item === void 0 ? void 0 : item.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase());
      })) === null || _a === void 0 ? void 0 : _a.category
    });
  }).sort((a, b) => {
    const listedTokenIndexA = listedTokens.findIndex(token => {
      var _a, _b, _c;
      return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = a === null || a === void 0 ? void 0 : a.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase());
    });
    const listedTokenIndexB = listedTokens.findIndex(token => {
      var _a, _b, _c;
      return ((_a = token === null || token === void 0 ? void 0 : token.token) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_c = (_b = b === null || b === void 0 ? void 0 : b.token) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.toLowerCase());
    });
    return listedTokenIndexA - listedTokenIndexB;
  });
  return {
    subMemeData,
    subMemeLoading,
    listedTokens
  };
}